import { useEffect, useState } from 'react';
import { Button, Group, Modal, Space } from '@mantine/core';

import LinkedModels from './linkedModels';
import MappingTable from './mappingTable';

import type { IEquipmentModel } from '../../../../../../../shared/apis/ai-agent/model/types';
import { useGetLinkedModels } from '../../../../../../../shared/apis/ai-agent/manual/reactQueries';
import { useParams } from 'react-router-dom';
import usePutLinkedModels from '../hooks/usePutLinkedModels';
import { map } from 'lodash';

interface ManualModelMappingModalProps {
  opened: boolean;
  onClose: () => void;
  fileUploadId: number | null;
}

export default function ManualModelMappingModal(props: ManualModelMappingModalProps) {
  const { opened, onClose, fileUploadId } = props;
  const { companyId } = useParams();
  const [selectedModels, setSelectedModels] = useState<IEquipmentModel[]>([]);

  const { data: linkedModels } = useGetLinkedModels({
    companyId: Number(companyId),
    fileUploadId: Number(fileUploadId),
  });

  const { mutate: mapManualModels } = usePutLinkedModels();

  useEffect(() => {
    if (!opened) return;

    if (linkedModels) {
      setSelectedModels(linkedModels.result);
    }
  }, [linkedModels, opened]);

  const handleToggleModel = (model: IEquipmentModel) => {
    setSelectedModels((prev) => {
      const isSelected = prev.some((selectedModel) => selectedModel.modelId === model.modelId);

      return isSelected ? prev.filter((selectedModel) => selectedModel.modelId !== model.modelId) : [...prev, model];
    });
  };

  const handleRemoveModel = (modelId: number) => {
    setSelectedModels((prev) => prev.filter((model) => model.modelId !== modelId));
  };

  const onSubmit = () => {
    if (!fileUploadId) return;
    if (!companyId) return;

    mapManualModels(
      {
        companyId: Number(companyId),
        fileUploadId: fileUploadId || 0,
        modelIds: map(selectedModels, 'modelId'),
      },
      {
        onSuccess: () => {
          onClose();
        },
      },
    );
  };

  return (
    <Modal title="기계모델 연동" opened={opened} onClose={onClose} centered size="lg">
      <LinkedModels data={selectedModels} onRemove={handleRemoveModel} />
      <MappingTable selectedModelIds={selectedModels.map((model) => model.modelId)} onToggleModel={handleToggleModel} />
      <Space h="lg" />
      <Group justify="center">
        <Button variant="outline" onClick={onClose} flex={1}>
          취소
        </Button>
        <Button flex={1} onClick={onSubmit}>
          저장
        </Button>
      </Group>
    </Modal>
  );
}
